import { useCallback, useEffect, useRef } from 'react';

const GenericSelect = ({
  selectClassName,
  selectOptions,
  changeSelectedOption,
  defaultValue
}: {
  selectClassName: string;
  selectOptions: JSX.Element[];
  changeSelectedOption: React.Dispatch<React.SetStateAction<any>>;
  defaultValue: any;
}) => {
  const refContainer = useRef<HTMLDivElement>(null);
  const onHandleClickAway = useCallback(
    async (e: IElement) => {
      if (refContainer.current && !refContainer.current.contains(e.target)) {
        changeSelectedOption(defaultValue);
      }
    },
    [refContainer, changeSelectedOption, defaultValue]
  );

  useEffect(() => {
    window.addEventListener('mousedown', onHandleClickAway);
    return () => {
      window.removeEventListener('mousedown', onHandleClickAway);
    };
  }, [onHandleClickAway]);

  return (
    <div ref={refContainer} className={selectClassName}>
      <div className="container-absolute">{selectOptions}</div>
    </div>
  );
};

export default GenericSelect;

export interface IElement {
  target: any;
}
